<div class="card-plan">
    <div class="card-header">
        <div class="plan-name">
            {{planPayment?.plan?.name}} <span class="recommended-plan" *ngIf="planPayment.plan?.slug == 'profissional'">Recomendado</span>
        </div>
    </div>
    <div class="card-body">
        <div class="card-description" [innerHtml]="planPayment?.description">
            
        </div>
        <div class="card-prices">
            <div class="detail-value">
                Valor equivalente mensal
            </div>
            <div class="card-primary-price">
                <strong>{{planPayment?.pricePerMonth | currency:'BRL'}}</strong><span>/mês</span>
            </div>
            <div class="card-secundary-price">
                <strong>{{planPayment?.price | currency:'BRL'}}</strong> por {{planPayment?.periodFormatted}}
            </div>

        </div>

        <button class="plan-btn top-plan-action" style="margin-top: 16px;" *ngIf="!isCurrentPlanPayment(); else actualTop" (click)="planRedirect()">Assinar</button>
        <button class="features-toggle" type="button" (click)="toggleFeatures()">
            {{ featuresExpanded ? 'Ocultar diferenciais' : 'Ver diferenciais' }}
            <mat-icon>{{ featuresExpanded ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</mat-icon>
        </button>
        <div style="margin-top: 16px;" class="features-container" [class.features-expanded]="featuresExpanded">
            <ng-container *ngFor="let feature of visibleFeatures()">
                <div class="feature-block" [class.feature-block-disabled]="isFeatureAbsent(feature)">
                    <img *ngIf="!isFeatureAbsent(feature)" src="/assets/svg/icons/circle_green_checkmark.svg" alt="">
                    <img *ngIf="isFeatureAbsent(feature)" src="/assets/svg/icons/error_mark.svg" alt="">

                    <div class="feature-content">
                        <div class="feature-line">
                            <span class="quantity-badge" *ngIf="hasQuantity(feature)">{{feature.label}}</span>
                            <span class="feature-title">{{ featureTitle(feature) }}</span>
                            <span class="unlimited-badge" *ngIf="feature.label === '*'">ilimitados</span>
                            <span class="period-label" *ngIf="feature.resettablePeriod == 1 && !isFeatureAbsent(feature)">por mês</span>
                        </div>
                        <div class="feature-details" *ngIf="featureDetails(feature) && isFeatureDetailsExpanded(feature)">
                            {{ featureDetails(feature) }}
                        </div>
                    </div>

                    <button class="feature-details-button" type="button" *ngIf="featureDetails(feature)" (click)="toggleFeatureDetails(feature)">
                        <mat-icon>{{ isFeatureDetailsExpanded(feature) ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</mat-icon>
                    </button>
                </div>
            </ng-container>
        </div>
        
    </div>
    <div class="card-footer">
        <button class="plan-btn" *ngIf="!isCurrentPlanPayment(); else actualBottom" (click)="planRedirect()">Assinar</button>
        <ng-template #actualBottom>
            <button *ngIf="canRenewCurrentPlan(); else currentBottom" style="margin-top: 13px;" class="current-btn renew-btn" (click)="renew()">Renovar</button>
            <ng-template #currentBottom>
                <button style="margin-top: 13px;" class="current-btn" disabled>Plano atual</button>
            </ng-template>
        </ng-template>
    </div>
</div>

<ng-template #actualTop>
    <button *ngIf="canRenewCurrentPlan(); else currentTop" style="margin-top: 16px;" class="current-btn renew-btn top-plan-action" (click)="renew()">Renovar</button>
    <ng-template #currentTop>
        <button style="margin-top: 16px;" class="current-btn top-plan-action" disabled>Plano atual</button>
    </ng-template>
</ng-template>
